<script>
//
export let pageCopy;
export let pageTitle;
export let buttonText;
export let buttonLink;
//
let theTitle;

 if(pageTitle!== null){
	theTitle=pageTitle;

}else{
	theTitle="";
}
</script>

<section>
    <div class="fic--cta_small-text">
    	      {#if theTitle !== ""}
              <h2>{@html theTitle}</h2>
            {/if}
            <div>
            <div class="fic--cta_text fic--cta_small-text_text">
        	   {@html pageCopy}

   		   </div>
           <div class="fic--cta_small-text_cta fic--button fic--button_cta-small">
            <a href="{buttonLink}" >{@html  buttonText }</a>
           </div>
        </div>
    </div>    
       
</section>